import { login, refresh, captcha, logout, getInfo, checkRole } from '@/api/userManage/user';
import { sysLogin } from '@/api/systemManage/systemManage';
import { getUndoNum } from '@/api/userManage/user';
import {
  getToken,
  setToken,
  removeToken,
  getAccessToken,
  setAccessToken,
  removeAccessToken,
  getWSToken,
  setWSToken,
  removeWSToken,
  setAccess,
} from '@/utils/auth';
import router, { resetRouter } from '@/router';

export default {
  namespaced: true,
  state: {
    token: getToken(),
    accessToken: getAccessToken(),
    wsToken: getWSToken(),
    userInfo: {},
    name: '',
    schoolName: '',
    avatar: '',
    introduction: '',
    isSelf: '',
    isSchool: '',
    roles: [],
    userSelectionCityList: [],
    userTypeList: [],
    undoNum: 0,
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_ACCESSTOKEN: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    SET_WSTOKEN(state, token) {
      state.wsToken = token;
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_SCHOOLNAME: (state, name) => {
      state.schoolName = name;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_USER_TYPE_LIST: (state, userTypeList) => {
      state.userTypeList = userTypeList;
    },
    SET_SELECTIONCITYL: (state, selectioncity) => {
      state.userSelectionCityList = selectioncity;
    },
    SET_ISSELF: (state, isSelf) => {
      state.isSelf = isSelf;
    },
    SET_ISSCHOOL: (state, isSchool) => {
      state.isSchool = isSchool;
    },
    SET_UNDO_NUM: (state, undoNum) => {
      state.undoNum = undoNum;
    },
  },
  actions: {
    // user login
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then((response) => {
            // console.log(response);
            const { data } = response;
            const access = data.access_token;
            const refresh = data.refresh_token;
            const wsToken = data.token;

            // Vuex
            commit('SET_TOKEN', access);
            commit('SET_ACCESSTOKEN', refresh);
            commit('SET_WSTOKEN', wsToken);
            // console.log(access);

            // Cookie
            setToken(access, data.expires_in);
            setAccessToken(refresh);
            setWSToken(wsToken);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sysLogin({ commit }, id) {
      return new Promise((resolve, reject) => {
        sysLogin(id)
          .then((response) => {
            // console.log(response);
            const { data } = response;
            const access = data.access_token;
            const refresh = data.refresh_token;
            const wsToken = data.token;

            // Vuex
            commit('SET_TOKEN', access);
            commit('SET_ACCESSTOKEN', refresh);
            commit('SET_WSTOKEN', wsToken);
            // console.log(access);

            // Cookie
            setToken(access, data.expires_in);
            setAccessToken(refresh);
            setWSToken(wsToken);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    refreshToken({ commit }, data) {
      return new Promise((resolve, reject) => {
        refresh(data)
          .then((response) => {
            const { data } = response;
            const access = data.access_token;
            const refresh = data.refresh_token;
            const wsToken = data.token;

            // Vuex
            commit('SET_TOKEN', access);
            commit('SET_ACCESSTOKEN', refresh);
            commit('SET_WSTOKEN', wsToken);

            // Cookie
            setToken(access, data.expires_in);
            setAccessToken(refresh);
            setWSToken(wsToken);

            resolve(data);
          })
          .catch((error) => {
            reject(error);
            if (error.message === '刷新token失败') {
              window.isRefreshing = false;
              removeAccessToken();
              router.replace('/');
            }
          });
      });
    },
    captcha({ commit }) {
      return new Promise((resolve, reject) => {
        captcha(new Date().getTime())
          .then((response) => {
            const { data } = response;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // get user info
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((response) => {
            const { data } = response;
            // console.log(data);
            if (!data) {
              reject('Verification failed, please Login again.');
            }

            let { id, roles, name, schoolName, avatar, isSelf, isSchool, userTypeList, selectionCityList } = data;
            if (roles.length === 0) {
              roles = ['info'];
            }

            // roles must be a non-empty array
            if (!roles || roles.length <= 0) {
              reject('getInfo: roles must be a non-null array!');
            }
            commit('SET_SELECTIONCITYL', selectionCityList);
            commit('SET_ROLES', roles);
            commit('SET_USER_TYPE_LIST', userTypeList || []);
            commit('SET_NAME', name);
            commit('SET_SCHOOLNAME', schoolName);
            commit('SET_ID', id);
            commit('SET_AVATAR', !avatar ? '/favicon.ico' : avatar);
            commit('SET_USERINFO', response);
            commit('SET_ISSELF', isSelf);
            commit('SET_ISSCHOOL', isSchool);

            resolve(data);
          })
          .catch((error) => {
            commit('SET_ROLES', ['info']);
            reject(error);
          });
      });
    },

    // user logout
    logout({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            // Vuex
            commit('SET_TOKEN', '');
            commit('SET_ACCESSTOKEN', '');
            commit('SET_WSTOKEN', '');
            commit('SET_ROLES', []);
            commit('SET_USER_TYPE_LIST', []);

            // Cookie
            removeToken();
            removeAccessToken();
            removeWSToken();

            window.location.href = '/';
            resetRouter();
            // reset visited views and cached views
            // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
            dispatch('tagsView/delAllViews', null, { root: true });

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // remove token
    resetToken({ commit }) {
      return new Promise((resolve) => {
        // Vuex
        commit('SET_TOKEN', '');
        commit('SET_ACCESSTOKEN', '');
        commit('SET_WSTOKEN', '');

        // Cookie
        removeToken();
        removeAccessToken();
        removeWSToken();

        resolve();
      });
    },

    checkRoleAction({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        checkRole(params).then(() => {
          dispatch('getInfo').then(res => {
            const { roles } = res;
            resetRouter();
            // generate accessible routes map based on roles
            dispatch('permission/generateRoutes', roles, { root: true }).then((accessRoutes) => {
              router.addRoutes(accessRoutes);
              dispatch('tagsView/delAllViews', null, { root: true });
            });
            resolve(res);
          });
        }).catch(error => {
          reject(error);
        });
      });
    },
    setUndoNum({ commit }) {
      return new Promise((resolve, reject) => {
        getUndoNum().then((res) => {
          commit('SET_UNDO_NUM', res.data);
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
  getters: {
    isSchool: state => state.isSchool,
    roles: state => state.roles,
    undoNum: state => state.undoNum,
    userSelectionCityList: state => state.userSelectionCityList,
  },
};
